interface Person {
	firstname: string;
	lastname: string;
}

interface Role {
	title?: string;
	people: string[];
}

interface Section {
	title: string;
	description?: string;
	roles: Role[];
}

interface CreditsData {
	description: string;
	sections: Section[];
}

// Helper function to sort people by lastname
function sortByLastname(people: Person[]): string[] {
	return [...people].sort((a, b) => a.lastname.localeCompare(b.lastname)).map((person) => `${person.firstname} ${person.lastname}`);
}

export const creditsData: CreditsData = {
	description:
		'Die BR24 Web App ist ein Digital-Produkt des Bayerischen Rundfunks. Das Team von BR24 arbeitet produktnah an der Weiterentwicklung und Optimierung des digitalen Nachrichtenangebotes und sorgt für die technische Stabilität.',
	sections: [
		{
			title: 'Entwicklungsteam',
			roles: [
				{
					title: 'Leitung Public Value Technologies GmbH',
					people: sortByLastname([{ firstname: 'Gert', lastname: 'Kauntz' }]),
				},
				{
					title: 'Projektkoordination Bayerischer Rundfunk',
					people: sortByLastname([{ firstname: 'Andreas', lastname: 'Fruth' }]),
				},
				{
					title: 'Product Owner',
					people: sortByLastname([{ firstname: 'Marie-Laurence', lastname: 'Wassermann' }]),
				},
				{
					title: 'Scrum Master',
					people: sortByLastname([
						{ firstname: 'Andreas', lastname: 'Grießer' },
						{ firstname: 'René', lastname: 'Bärje-Keßler' },
					]),
				},
				{
					title: 'Android App',
					people: sortByLastname([
						{ firstname: 'Florian', lastname: 'Thoma' },
						{ firstname: 'Christian', lastname: 'Gerhards' },
						{ firstname: 'Gabriel', lastname: 'Vrebac' },
					]),
				},
				{
					title: 'iOS App',
					people: sortByLastname([
						{ firstname: 'Oliver', lastname: 'Brehm' },
						{ firstname: 'Arlind', lastname: 'Aliu' },
					]),
				},
				{
					title: 'Web- und Backend-Entwicklung',
					people: sortByLastname([
						{ firstname: 'Thomas', lastname: 'Mair' },
						{ firstname: 'Rosen', lastname: 'Ralev' },
					]),
				},
				{
					title: 'Site Reliability Engineering',
					people: sortByLastname([]),
				},
				{
					title: 'Design',
					people: sortByLastname([{ firstname: 'Alexander', lastname: 'Stahl' }]),
				},
				{
					title: 'QS',
					people: sortByLastname([
						{ firstname: 'Rene', lastname: 'Metzger' },
						{ firstname: 'Kris', lastname: 'Stanton' },
					]),
				},
				{
					title: 'Userlab',
					people: sortByLastname([]),
				},
			],
		},
		{
			title: 'Informationsdirektion',
			roles: [
				{
					title: 'Chefredakteur',
					people: sortByLastname([{ firstname: 'Christian', lastname: 'Nitsche' }]),
				},
				{
					title: 'Leitung Redaktion BR24-Digital',
					people: sortByLastname([{ firstname: 'Gudrun', lastname: 'Riedl' }]),
				},
				{
					title: 'Projektmanagement BR24-Digital',
					people: sortByLastname([{ firstname: 'Birgit', lastname: 'Gamböck' }]),
				},
			],
		},
		{
			title: 'BR24 Alumni',
			roles: [
				{
					people: [
						'Andrea Mittlmeier',
						'Andreas Reiser',
						'Daniel Büchele',
						'Daniel Krax',
						'Ina Klautke',
						'Joan Disho',
						'Johann Rottenfusser',
						'John-Louis Gao',
						'Laura Mühlbach',
						'Marc Binder',
						'Max Karadeniz',
						'Milena Zurmühl',
						'Mustafa Kurtulus Isik',
						'Patricia Stuchlik',
						'Philipp Dressel',
						'Raphaela Ernst',
						'Raphaela Fischer',
						'Samuel Radimak',
						'Sebastian Mark',
						'Wolfgang Vichtl',
						'Jennifer Martens-Späth',
						'Tanner Hoisington',
						'Divyanshu Rawat',
						'Andrea Wildberger',
						'Christian Bulmahn',
						'Gabriel Knoll',
						'Anny Rey',
						'Tanja Buchmann',
						'Sven Schulz',
						'Mischa Hildebrand',
						'Joseph Saroufim',
						'Alexander Türk',
						'Maximilian Meyer',
						'Danny Forster',
						'Andreas Hubel',
						'Bastian Kirschner',
						'Steffi Brau',
						'Bastian Kistner',
						'Daniel Schmid',
						'Fabian Hartmann',
						'Hans Schötz',
						'Elias Rami',
						'Thomas Günzel',
						'Vanessa Modjesch',
						'Bianca Nawar',
						'Chiara Stieger',
					],
				},
			],
		},
	],
};
